
function requestAPI(data, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}producer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(data)
  }).then((res) => res.json())
}

export default function actionSaveProducer(data) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'SAVE_PRODUCER_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(data, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'SAVE_PRODUCER_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'SAVE_PRODUCER_FAILURE',        
    error: error    
  })
}